import classNames from 'classnames';
import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ListingActionTypes } from '@state/features/common.types';
import Metatags from '@components/common/Metatags';
import Breadcrumbs from '@components/listing/Breadcrumb';
import ListingResults from '@stone/components/listing/ListingResults';
import ListingPagination from '@stone/components/listing/ListingPagination';
import ProductFilters from '@stone/components/listing/ProductFilters';
import PlpHero from '@stone/components/listing/PlpHero';
import StoryListing from '../storylisting/StoryListing';
import { useLocation } from 'react-router-dom';
import { useAnimatedContext } from '../routerTransitions/AnimatedProvider';
import analytics from '@stone/utils/analytics';
const Plp = (props) => {
    var _a, _b, _c;
    const { search: { category, pageMetaTags, resultsType, plpintro, bottomregion, firstLoad }, } = useSelector((state) => state);
    const { subscribe, unsubscribe } = useAnimatedContext();
    const { state } = useLocation();
    useTranslation(); // force immediate loading of translations
    const dispatch = useDispatch();
    const listingContainer = useRef();
    const firstShow = useRef(true);
    const sendAnalyticsEvents = () => {
        // composing subCategory as per OE-5541
        window.datalayerdata = Object.assign(Object.assign({}, window.datalayerdata), { pageCategory: 'plp' });
        analytics.sendGeneralVariables();
    };
    // initial products list fetch
    useEffect(() => {
        if (!resultsType) {
            dispatch({
                type: ListingActionTypes.UPDATE_GRID_INDEXES,
                payload: (props === null || props === void 0 ? void 0 : props.rowsindexes) ? JSON.parse(props === null || props === void 0 ? void 0 : props.rowsindexes) : [],
            });
            dispatch({
                type: ListingActionTypes.FETCH_LISTING,
                payload: {
                    cgid: props.cgid,
                    slug: location.pathname,
                    resultsType: 'INIT',
                    start: parseInt(props.start),
                    isShelf: false,
                    tier: props.tier,
                },
            });
        }
    }, []);
    //Send analitycs on first render
    useEffect(() => {
        if (firstShow.current && window.datalayerdata.pageCategory !== 'plp') {
            // intercept the return from pdp by spa and send the pageLoad event
            sendAnalyticsEvents();
        }
        firstShow.current = false;
        return () => {
            firstShow.current = true;
        };
    }, []);
    useLayoutEffect(() => {
        //TRACK ITEMS IN PLP ON TRANSITION BACK
        const fn = () => {
            var _a, _b;
            if (((_a = state === null || state === void 0 ? void 0 : state.transition) === null || _a === void 0 ? void 0 : _a.direction) === 'out' && ((_b = state === null || state === void 0 ? void 0 : state.transition) === null || _b === void 0 ? void 0 : _b.productId)) {
                dispatch({
                    type: ListingActionTypes.TRACKBACK_LISTING,
                });
            }
        };
        subscribe('setup', fn);
        return () => {
            unsubscribe('setup', fn);
        };
    }, [state]);
    if (!category) {
        return React.createElement("div", { className: "tmploader", dangerouslySetInnerHTML: { __html: props.placeholder } });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Metatags, { pageMetaTags: pageMetaTags, meta: category.meta }),
        React.createElement("div", { ref: listingContainer, className: classNames('listing-container') },
            React.createElement(PlpHero, null),
            React.createElement(ProductFilters, { plpintro: plpintro, willStick: true, tier: props.tier }),
            React.createElement(ListingResults, { cgid: props.cgid, tier: props.tier }),
            React.createElement(ListingPagination, Object.assign({}, props)),
            React.createElement(Breadcrumbs, { cgid: props.cgid }),
            (bottomregion === null || bottomregion === void 0 ? void 0 : bottomregion.length) > 0 && ((_b = (_a = bottomregion[0]) === null || _a === void 0 ? void 0 : _a.regions) === null || _b === void 0 ? void 0 : _b.stories) && React.createElement(StoryListing, { title: bottomregion[0].title, stories: (_c = bottomregion[0].regions.stories) === null || _c === void 0 ? void 0 : _c.components }))));
};
export default Plp;
